import { getCookie, setCookie } from '../utils/cookie-functions';

let interval;
let gpcApplied = false;

// Use a constant for the category code
const TARGETING_CATEGORY = 'C0004';

const safeUpdateConsent = (category, value, retries = 3) => {
  try {
    if (window.OneTrust?.UpdateConsent) {
      window.OneTrust.UpdateConsent('Category', `${category}:${value}`);
    } else if (retries > 0) {
      setTimeout(() => safeUpdateConsent(category, value, retries - 1), 800);
    }
  } catch {
    if (retries > 0) setTimeout(() => safeUpdateConsent(category, value, retries - 1), 800);
  }
};

const detectGPC = () => {
  try {
    if (navigator.globalPrivacyControl === true) return true;
  } catch {
    // continue
  }

  const isBrave =
    (navigator.brave && typeof navigator.brave.isBrave === 'function') ||
    (navigator.userAgent || '').includes('Brave') ||
    (window.clientInformation?.brands || []).map((b) => b.brand).some((b) => /brave/i.test(b));

  const isFirefox =
    /firefox/i.test(navigator.userAgent) ||
    (window.clientInformation?.brands || []).some((b) => /firefox/i.test(b.brand));

  return isBrave || isFirefox;
};

export const setGpcOneTrust = () => {
  const hasGpc = detectGPC();
  if (!hasGpc || gpcApplied || !window.OneTrust) return;

  const domainDataReady = !!(window.OneTrust.GetDomainData && window.OneTrust.GetDomainData());
  const activeGroupsReady = typeof window.OnetrustActiveGroups !== 'undefined';
  if (!domainDataReady && !activeGroupsReady) return;

  safeUpdateConsent(TARGETING_CATEGORY, 0);
  window.OneTrust.gpcEnabled = true;
  gpcApplied = true;

  if (!getCookie('limittheuse')) setCookie('limittheuse', true, 365);
  if (!getCookie('donotsell')) setCookie('donotsell', true, 365);

  const banner = document.getElementById('onetrust-banner-sdk');
  if (banner) {
    const enforceVisible = () => {
      banner.style.setProperty('display', 'block', 'important');
      banner.style.setProperty('opacity', '1', 'important');
      banner.style.setProperty('visibility', 'visible', 'important');
      banner.style.setProperty('pointer-events', 'auto', 'important');
      banner.style.setProperty('height', 'auto', 'important');
    };
    enforceVisible();

    const observer = new MutationObserver(() => {
      if (banner.style.display === 'none') enforceVisible();
    });
    observer.observe(banner, { attributes: true, attributeFilter: ['style'] });
  }

  clearInterval(interval);
};

const getConsentGroups = () => {
  const shopifyConsentCookie = getCookie('_tracking_consent');
  let shopifyConsentCookieJSON = null;
  try {
    if (shopifyConsentCookie) {
      shopifyConsentCookieJSON = JSON.parse(decodeURIComponent(shopifyConsentCookie));
    }
  } catch {
    // ignore
  }

  const shopifyConsentGroups = shopifyConsentCookieJSON?.cus?.['onetrust.groups'];
  const optanonConsentGroups = window.OnetrustActiveGroups;
  return { shopifyConsentGroups, optanonConsentGroups };
};

export const overrideDNS = () => {
  if (!window.OneTrust) return;

  const { shopifyConsentGroups, optanonConsentGroups } = getConsentGroups();
  const isLimitTheUse = getCookie('limittheuse');
  const isDoNotSell = getCookie('donotsell');

  const shouldOverride =
    (isLimitTheUse || isDoNotSell) &&
    (shopifyConsentGroups?.includes(`${TARGETING_CATEGORY}:1`) || optanonConsentGroups?.includes(TARGETING_CATEGORY));

  if (shouldOverride) {
    setTimeout(() => {
      safeUpdateConsent(TARGETING_CATEGORY, 0);
      const checkInterval = setInterval(() => {
        const { shopifyConsentGroups: updated } = getConsentGroups();
        if (updated?.includes(`${TARGETING_CATEGORY}:0`)) {
          clearInterval(checkInterval);
          window.location.reload();
        }
      }, 250);
    }, 1500);
  }

  clearInterval(interval);
};

function initConsentManager() {
  const attempt = () => {
    if (window.OneTrust) {
      setGpcOneTrust();
      overrideDNS();
    }
  };
  interval = setInterval(attempt, 800);
  attempt();
  document.addEventListener('OneTrustLoaded', attempt);
}

document.addEventListener('DOMContentLoaded', initConsentManager);
